import { render, staticRenderFns } from "./ElementMedia.vue?vue&type=template&id=fe39b598&"
import script from "./ElementMedia.vue?vue&type=script&lang=js&"
export * from "./ElementMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports